import React from "react";

export default function Container({ children, className = "" }) {
    return (
        <div className={`max-w-container mx-auto px-4 sm:px-6 md:px-8 lg:px-10 ${className}`}>
            {children}
        </div>
    );
}
